"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Sync_1 = require("./Sync");
var SyncUtils_1 = require("../SyncUtils");
var PathUtils = require("../PathUtils");
var qs = require("qs");
var Id = require("../Id");
var StateManager_1 = require("./StateManager");
var IdPrefix = "app-host-";
var nextId = function () {
    return Id.next(IdPrefix);
};
exports.nextId = nextId;
var AbstractAppHost = /** @class */ (function (_super) {
    __extends(AbstractAppHost, _super);
    function AbstractAppHost() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sync = new Sync_1.Sync();
        _this._root = false;
        _this._initialized = false;
        _this._loadDone = function (value) {
            _this.view = value;
            _this.sync.syncEnd();
        };
        _this._loadError = function (error) {
            console.log("App Host Load Error");
            console.warn(error);
            _this.sync.syncError(error);
        };
        return _this;
    }
    Object.defineProperty(AbstractAppHost.prototype, "id", {
        get: function () {
            if (!this._id) {
                this._id = nextId();
            }
            return this._id;
        },
        set: function (value) {
            this.setId(value);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setId = function (id) {
        this._id = id;
    };
    Object.defineProperty(AbstractAppHost.prototype, "root", {
        get: function () {
            return this._root;
        },
        set: function (value) {
            this.setRoot(value);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setRoot = function (root) {
        this._root = root;
    };
    Object.defineProperty(AbstractAppHost.prototype, "router", {
        get: function () {
            return this._router;
        },
        set: function (router) {
            this.setRouter(router);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setRouter = function (router) {
        if (router !== this._router) {
            this._router = router;
            if (this._initialized) {
                this._loadImpl();
            }
        }
    };
    Object.defineProperty(AbstractAppHost.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        set: function (value) {
            this.setInitialized(value);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setInitialized = function (initialized) {
        this._initialized = initialized;
    };
    Object.defineProperty(AbstractAppHost.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this.setTitle(value);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setTitle = function (title) {
        this._title = title;
    };
    Object.defineProperty(AbstractAppHost.prototype, "url", {
        get: function () {
            return this.getUrl(this.request);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.getUrl = function (request) {
        var initPath = request && request.path ? request.path : this.path;
        var url = initPath ? PathUtils.join(PathUtils.sep, initPath) : "";
        var queryString;
        if (request && request.query) {
            queryString = qs.stringify(request.query);
        }
        if (queryString) {
            url += "?" + queryString;
        }
        return url;
    };
    AbstractAppHost.prototype.setView = function (view) {
        this.view = view;
    };
    AbstractAppHost.prototype._loadImpl = function () {
        this.sync.syncStart();
        if (this.router) {
            var req = Object.assign({}, this.request, { app: this, host: this });
            // NOTE: merging query into params
            req.params = Object.assign({}, req.query, req.params);
            return Promise.resolve(this.router.handleRequest(req)).then(this._loadDone).catch(this._loadError);
        }
        else {
            this._loadError({ code: "ILLEGAL_STATE", message: "No Router configured" });
        }
    };
    AbstractAppHost.prototype._init = function (request) {
        this.setRequest(request || this.defaultRequest);
        return this._loadImpl();
    };
    AbstractAppHost.prototype._pushHistory = function (url) {
        // does nothing by default
    };
    AbstractAppHost.prototype.load = function (request) {
        if (!request && this.sync.syncing) {
            return SyncUtils_1.toPromise(this.sync);
        }
        if (request && request.title) {
            this.setTitle(request.title);
        }
        if (!this._initialized) {
            this._initialized = true;
            return this._init(request);
        }
        var currentUrl = this.url;
        this.setRequest(request || this.defaultRequest);
        var url = this.getUrl(this.request);
        if (url !== currentUrl) {
            this._pushHistory(url);
            return this._loadImpl();
        }
        return Promise.resolve(this.view);
    };
    Object.defineProperty(AbstractAppHost.prototype, "defaultRequest", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractAppHost.prototype, "request", {
        get: function () {
            return Object.assign({}, this._request);
        },
        set: function (value) {
            this.setRequest(value);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.setRequest = function (request) {
        this._request = request;
    };
    AbstractAppHost.prototype.clearRequest = function () {
        this._request = undefined;
    };
    Object.defineProperty(AbstractAppHost.prototype, "path", {
        get: function () {
            var r = this.request;
            return r ? r.path : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractAppHost.prototype, "params", {
        get: function () {
            var r = this.request;
            return Object.assign({}, r ? r.query : undefined, r ? r.params : undefined);
        },
        enumerable: true,
        configurable: true
    });
    AbstractAppHost.prototype.toJSON = function () {
        return { id: this.id };
    };
    __decorate([
        mobx_1.observable
    ], AbstractAppHost.prototype, "_title", void 0);
    __decorate([
        mobx_1.observable
    ], AbstractAppHost.prototype, "sync", void 0);
    __decorate([
        mobx_1.observable.ref
    ], AbstractAppHost.prototype, "view", void 0);
    __decorate([
        mobx_1.observable
    ], AbstractAppHost.prototype, "_root", void 0);
    __decorate([
        mobx_1.observable
    ], AbstractAppHost.prototype, "_request", void 0);
    __decorate([
        mobx_1.observable
    ], AbstractAppHost.prototype, "_initialized", void 0);
    __decorate([
        mobx_1.computed
    ], AbstractAppHost.prototype, "root", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setRoot", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setRouter", null);
    __decorate([
        mobx_1.computed
    ], AbstractAppHost.prototype, "initialized", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setInitialized", null);
    __decorate([
        mobx_1.computed
    ], AbstractAppHost.prototype, "title", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setTitle", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setView", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "_loadDone", void 0);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "_loadError", void 0);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "_loadImpl", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "load", null);
    __decorate([
        mobx_1.computed
    ], AbstractAppHost.prototype, "request", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "setRequest", null);
    __decorate([
        mobx_1.action
    ], AbstractAppHost.prototype, "clearRequest", null);
    return AbstractAppHost;
}(StateManager_1.StateManager));
exports.AbstractAppHost = AbstractAppHost;
